import React, { useEffect } from "react"
import { Text } from "@veeqo/ui"
import { Wrapper, Card } from "./styling/styled";
import { Animation } from './components/Animation';
import { Tick } from "./components/Tick";
import { usePolling } from "./utils/usePolling";
import { content, ContentType } from "./content/content";
import './styling/SeCe.css'

const DELAY_TIME = 1_000;

export const Splash = ({contentType}: {contentType: ContentType }) => {
  const [readyDelayed, setReadyDelayed] = React.useState(false);
  const { status, ready } = usePolling({ contentType });

  useEffect(() => {
    if (ready) setTimeout(() => {setReadyDelayed(true)}, DELAY_TIME);
  });

  return (
    <Wrapper>
      <Card>
        <Text
          as="h1"
          variant="headingLarge"
          style={{ color: "var(--nordic)" }}
        >
          {content[contentType].title}
        </Text>
        <Text
          as="p"
          variant="body"
          style={{
            color: "var(--nordic)",
            minHeight: '40px',
            display: 'flex',
            alignItems: 'center',
          }}
        >{ready ? content[contentType].status.READY.text : status}</Text>
        {!readyDelayed && <Animation finishAnimation={ready} />}
        {readyDelayed && <Tick />}
      </Card>
    </Wrapper>
  )
}